import classNames from "classnames";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import React from "react";
import SelectableDiv from "../../SelectableDiv";
import { SearchInput } from "components/Atoms/SearchInput";

interface Props<T> {
  selectedItems: T[]
  items: T[]
  onItemToggled: (item: T) => void
  getId: (item: T) => number | string
  getName: (item: T) => string
  getSubLabel?: (item: T) => string
  noScrolling?: boolean
  noSearch?: boolean
  renderItem?: (item: T) => React.ReactNode
}

const SelectableList = <T extends unknown>(props: Props<T>) => {
  const [filter, setFilter] = React.useState<string>("");

  const selectedIds = new Set(props.selectedItems.map(i => props.getId(i)));

  const shouldHaveScrollbar = !props.noScrolling;

  const classes = classNames({
    "scrollbox-auto": shouldHaveScrollbar
  });

  const showFilter = !props.noSearch && props.items.length > 10;

  const filterFn = (item: T) => {
    const includesName = props.getName(item).toLowerCase().includes(filter.toLowerCase());
    const includesSubLabel = props.getSubLabel && props.getSubLabel(item).toLowerCase().includes(filter.toLowerCase());
    return includesName || includesSubLabel;
  };

  const filteredResult = showFilter ? props.items.filter(filterFn) : props.items;

  return <div>
    {showFilter && <div className="margin-bottom">
      <SearchInput
        placeholder={RESX.GeneralLabels.Search}
        focusOnMount
        value={filter}
        onChange={setFilter}
      />
    </div>}
    <div className={classes} style={shouldHaveScrollbar ? { maxHeight: 300 } : undefined}>
      {filteredResult.map((item, idx) => {
        const id = props.getId(item);
        const name = props.getName(item);
        const subLabel = props.getSubLabel?.(item);
        return <SelectableDiv
          group="selectableList"
          key={id}
          selected={selectedIds.has(id)}
          value={id}
          onClick={() => { props.onItemToggled(item); }}
          autoFocus={idx === 0 && !showFilter}
        >
          {!props.renderItem && <>
            {name}
            {subLabel && <div className="text-sublabel">{subLabel}</div>}
          </>}
          {props.renderItem && props.renderItem(item)}
        </SelectableDiv>;
      })}
      {filteredResult.length === 0 && <NoDataAvailableDiv />}
    </div>
  </div>;
};

export default SelectableList;